import { render } from "./RollGameWin.vue?vue&type=template&id=40ffc790&scoped=true"
import script from "./RollGameWin.vue?vue&type=script&lang=js"
export * from "./RollGameWin.vue?vue&type=script&lang=js"

import "./RollGameWin.vue?vue&type=style&index=0&id=40ffc790&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ffc790"]])

export default __exports__